var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "event_center" } }, [
    _c(
      "div",
      { staticClass: "close-btn", on: { click: _vm.on_close_button_click } },
      [_vm._v("x")]
    ),
    _c("div", { staticClass: "event-container" }, [
      _c("div", { staticClass: "header" }, [
        _c(
          "div",
          {
            class: { active: _vm.category == 0 },
            on: {
              click: function ($event) {
                _vm.category = 0
              },
            },
          },
          [_c("span", [_vm._v("活动")])]
        ),
        _c(
          "div",
          {
            class: { active: _vm.category == 1 },
            on: {
              click: function ($event) {
                _vm.category = 1
              },
            },
          },
          [_c("span", [_vm._v("战力")])]
        ),
        _vm.user.isCompensationQualified
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.user.nickname != null,
                    expression: "user.nickname != null",
                  },
                ],
                class: { active: _vm.category == 6 },
                on: {
                  click: function ($event) {
                    _vm.category = 6
                  },
                },
              },
              [_c("span", [_vm._v("救援")])]
            )
          : _vm._e(),
        _c(
          "div",
          {
            class: { active: _vm.category == 3 },
            on: {
              click: function ($event) {
                _vm.category = 3
              },
            },
          },
          [_c("span", [_vm._v("CDK")])]
        ),
        _c(
          "div",
          {
            class: { active: _vm.category == 4 },
            on: {
              click: function ($event) {
                _vm.category = 4
              },
            },
          },
          [_c("span", [_vm._v("VIP")])]
        ),
      ]),
      _vm.category == 0
        ? _c(
            "div",
            { staticClass: "event-tab st_scroll_d" },
            [!_vm.$screen.mobile ? _c("c-eventList") : _c("c-m-eventList")],
            1
          )
        : _vm._e(),
      _vm.category == 1
        ? _c(
            "div",
            { staticClass: "event-tab st_scroll_d" },
            [_c("c-rebate")],
            1
          )
        : _vm._e(),
      _vm.category == 2
        ? _c(
            "div",
            { staticClass: "event-tab st_scroll_d" },
            [
              _c("c-freebox", {
                on: { close_button_click: _vm.on_close_button_click },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.category == 3
        ? _c(
            "div",
            { staticClass: "event-tab st_scroll_d" },
            [_c("c-redEnvelope")],
            1
          )
        : _vm._e(),
      _vm.category == 4
        ? _c(
            "div",
            { staticClass: "event-tab st_scroll_d" },
            [
              _c("c-vip", {
                on: {
                  on_receive: function ($event) {
                    _vm.category = 3
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.category == 5
        ? _c(
            "div",
            { staticClass: "event-tab st_scroll_d" },
            [
              _c("c-rolls", {
                on: { close_button_click: _vm.on_close_button_click },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.category == 6
        ? _c(
            "div",
            { staticClass: "event-tab st_scroll_d" },
            [
              _c("c-subsidy", {
                on: { close_button_click: _vm.on_close_button_click },
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }